import {createTheme} from '@mui/material';

import {scrollbar} from './customColors';
import {darkPalette} from './darkPalette';
import {
  sharedTypography,
  sharedBreakpoints,
  sharedTypographyOverrides,
} from './sharedThemeConfig';

/**
 * Erster Durchlauf: Basis-Theme mit Palette, Typografie und Breakpoints erstellen,
 * damit Palette-Tokens in den Komponenten-Overrides referenziert werden können.
 */
const baseTheme = createTheme({
  palette: darkPalette,
  typography: sharedTypography,
  breakpoints: sharedBreakpoints,
});

export const darkTheme = createTheme(baseTheme, {
  components: {
    MuiDialogTitle: {
      styleOverrides: {
        root: {backgroundColor: baseTheme.palette.background.paper},
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {backgroundColor: baseTheme.palette.background.paper},
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          color: baseTheme.palette.common.white,
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: baseTheme.palette.background.paper,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: baseTheme.palette.background.paper,
        },
      },
      defaultProps: {variant: 'outlined'},
    },
    MuiMenu: {defaultProps: {slotProps: {paper: {variant: 'elevation'}}}},
    MuiCard: {
      styleOverrides: {
        root: {
          '&.selected': {
            backgroundColor: baseTheme.palette.secondary.main,
          },
        },
      },
    },
    MuiTypography: sharedTypographyOverrides,
    MuiButton: {
      styleOverrides: {
        contained: {
          '&:hover': {
            boxShadow: 8,
            color: baseTheme.palette.common.black,
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {'&:focus': {backgroundColor: 'transparent'}},
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          backgroundColor: baseTheme.palette.background.paper,
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: baseTheme.palette.background.paper,
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          backgroundColor: baseTheme.palette.background.paper,
          '&.Mui-selected': {
            backgroundColor: baseTheme.palette.secondary.main,
          },
          '&.MuiTableRow-hover:hover': {
            backgroundColor: baseTheme.palette.secondary.light,
          },
          '&.Mui-selected.MuiTableRow-hover:hover': {
            backgroundColor: baseTheme.palette.secondary.dark,
          },
        },
      },
    },
    MuiTreeItem: {
      styleOverrides: {
        content: {
          '&:hover': {
            backgroundColor: baseTheme.palette.secondary.light,
          },
          '&[data-selected]:hover, &[data-selected][data-focused]:hover': {
            backgroundColor: baseTheme.palette.secondary.dark,
          },

          '&[data-selected], &[data-selected][data-focused]': {
            backgroundColor: baseTheme.palette.secondary.main,
          },
          '&[data-focused]': {
            backgroundColor: 'transparent',
          },
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        '*, *::before, *::after': {
          fontFamily: 'Lato, sans-serif !important',
        },
        body: {
          backgroundColor: baseTheme.palette.background.default,
          backgroundImage: 'none',
          scrollbarColor: `${scrollbar.thumb} ${scrollbar.track}`,
          '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
            backgroundColor: scrollbar.track,
            width: 8,
            height: 8,
          },
          '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
            backgroundColor: scrollbar.thumb,
          },
          '&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus':
            {
              backgroundColor: scrollbar.hover,
            },
          '&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active':
            {
              backgroundColor: scrollbar.hover,
            },
          '&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover':
            {
              backgroundColor: scrollbar.hover,
            },
          '&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner': {
            backgroundColor: scrollbar.hover,
          },
        },
      },
    },
  },
});
